// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: var(--app-search-width, 100%);
  min-width: var(--app-search-min-width, 0);
}

ion-searchbar {
  width: 100%;
  --background: transparent;
  --box-shadow: none;
}

ion-searchbar::part(container) {
  background: transparent;
  box-shadow: none;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/header/search-component/search-component.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,oCAAA;EACA,yCAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;EACA,gBAAA;EACA,YAAA;AACF","sourcesContent":[":host {\n  display: block;\n  width: var(--app-search-width, 100%);\n  min-width: var(--app-search-min-width, 0);\n}\n\nion-searchbar {\n  width: 100%;\n  --background: transparent;\n  --box-shadow: none;\n}\n\nion-searchbar::part(container) {\n  background: transparent;\n  box-shadow: none;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
